import React from "react";
import Slider from "react-slick";
import {
  Box,
  Typography,
  Rating,
  useTheme,
  useMediaQuery,
  Avatar,
  Grid,
} from "@mui/material";

const CustomerReviews = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const reviewImages = [
    "1.png",
    "2.png",
    "3.png",
    "4.png",
    "5.png",
    ];

  const reviews = [
    {
      name: "Aarav Sharma",
      text: "Delicious kulchas! Perfect spice and quality. Will definitely come back!",
      rating: 5,
    },
    {
      name: "Meera Jain",
      text: "Absolutely loved the ambience and the variety. Must try!",
      rating: 4.5,
    },
    {
      name: "Rohit Verma",
      text: "Hands down the best kulchas I’ve had in India.",
      rating: 5,
    },
  ];

  const photoSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
  };

  return (
    <Box sx={{ py: 6, px: { xs: 2, md: 6 }, bgcolor: "#FFF8E1" }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        mb={1}
        sx={{ color: "#FCA500" }}
      >
        Loved by 20000+ Customers
      </Typography>

      <Typography
        variant="body2"
        textAlign="center"
        color="#666"
        mb={3}
        sx={{ fontSize: isMobile ? "0.8rem" : "0.9rem" }}
      >
        With an outstanding 4.8★ rating on Google across all our outlets
      </Typography>

      <Slider {...photoSettings}>
        {reviewImages.map((img, i) => (
          <Box key={i} sx={{ px: 1 }}>
            <Box
              component="img"
              src={img}
              alt={`Customer Review ${i + 1}`}
              sx={{
                width: "100%",
                height: isMobile ? 300 : 500,
                objectFit: "cover",
                borderRadius: 3,
                boxShadow: 2,
              }}
            />
          </Box>
        ))}
      </Slider>

    </Box>
  );
};

export default CustomerReviews;
